// src/components/orderentry/components/GridBadge.jsx
import React from 'react';

import Box from '@mui/material/Box';

// Toggle to show/hide the badge overlays
const SHOW_BADGES = false;

/**
 * Debug badge for grid areas (1..5).
 * Useful while iterating on layout.
 */
export default function GridBadge({ n }) {
  if (!SHOW_BADGES) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 6,
        left: 6,
        px: 0.75,
        py: 0.25,
        fontSize: 12,
        lineHeight: 1,
        fontWeight: 700,
        borderRadius: 0.75,
        bgcolor: 'warning.main',
        color: 'warning.contrastText',
        zIndex: 10,
        opacity: 0.9,
        userSelect: 'none',
        pointerEvents: 'none',
      }}
    >
      {n}
    </Box>
  );
}
